/** @jsxImportSource @emotion/react */
"use client";
import type { FunctionInterpolation } from "@emotion/react";
import { forwardRef } from "react";

import type { HallowElement } from "../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import type { WithAsChild } from "../../../../types/withAsChild.types";
import { determineElementFromAsChild } from "../../../../utils/determineElementFromAsChild";

const hallowElement: HallowElement = "div";

export type StackProps = { gap?: string } & WithAsChild<
  HallowElementProps<typeof hallowElement>
>;

const stackStyle: FunctionInterpolation<{ gap?: string }> = ({ gap }) => ({
  display: "flex",
  flexDirection: "column",
  gap: gap ?? undefined,
});

export const Stack = forwardRef<any, StackProps>(
  ({ asChild = false, children, gap, ...props }, ref) => {
    const DeterminedElement = determineElementFromAsChild({
      asChild,
      hallowElement,
    });

    return (
      <DeterminedElement ref={ref} css={stackStyle({ gap })} {...props}>
        {children}
      </DeterminedElement>
    );
  },
);

Stack.displayName = "Stack";
